
import { onMounted, shallowRef } from '@vue/composition-api';
const __sfc_main = {};
__sfc_main.props = {
  modelValue: {
    key: "modelValue",
    required: false,
    type: String
  },
  isShowIcon: {
    key: "isShowIcon",
    required: false,
    type: Boolean,
    default: true
  },
  placeholder: {
    key: "placeholder",
    required: false,
    type: String
  },
  error: {
    key: "error",
    required: false,
    type: Boolean,
    default: false
  },
  padding: {
    key: "padding",
    required: false,
    type: String,
    default: '9px 35px 10px 14px'
  },
  height: {
    key: "height",
    required: false,
    type: Number,
    default: 39
  },
  border: {
    key: "border",
    required: false,
    type: String,
    default: '1px solid #e5e5e5'
  },
  borderRadius: {
    key: "borderRadius",
    required: false,
    type: String,
    default: '4px'
  }
};
__sfc_main.setup = (__props, __ctx) => {
  const emit = __ctx.emit;
  const textareaRef = shallowRef<HTMLTextAreaElement>();
  onMounted(() => {
    textareaRef.value?.focus();
    recalculateHeightTextarea();
  });
  function recalculateHeightTextarea() {
    if (textareaRef.value) {
      textareaRef.value.style.height = '0px';
      textareaRef.value.style.height = `${textareaRef.value.scrollHeight}px`;
    }
  }
  function onInput(e: Event) {
    recalculateHeightTextarea();
    if (e.target instanceof HTMLTextAreaElement) emit('update:model-value', e.target.value);
  }
  return {
    emit,
    textareaRef,
    onInput
  };
};
export default __sfc_main;
